import { Component, HostListener, OnInit } from '@angular/core';
import { LanguageService } from '../../services/language.service';
import { interval,Subscription } from 'rxjs';
import { HomeService } from '../../../module/home/home.service';
import { environment } from '../../../../environments/environment.development';
import { image } from 'pdfkit';
import { CitizenService } from '../../../module/citizen/citizen.service';
import { v4 as uuidv4 } from 'uuid';

declare const bootstrap: any;


@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent implements OnInit {
  socialicon = [{ icon: "Facebook.svg", name: 'Facebook' }, { icon: "instagram.svg", name: 'Instagram' }, { icon: "twitter.svg", name: 'Twitter' }];
  constructor(public langService: LanguageService, private homeService: HomeService,
    private citizenService: CitizenService,) { }

  visitorId = sessionStorage.getItem('visitorId');
  ip='';
  browserInfo='';
  platform='';
  private timerSub!: Subscription;
  async ngOnInit(){
    //this.getIntegratedSectionData();
    this.getQucikLinkFooterSectionData();
    await this.ChangeLanguageSettings();

    this.SubscribeLanguage();
    this.initializeModals();
    if (this.visitorId === null) {
      this.ip = await this.GetIP();
      this.visitorId = uuidv4();
      this.browserInfo = navigator.userAgent;
      this.platform = navigator.platform;
      sessionStorage.setItem('visitorId', this.visitorId);
      this.InsertVisitor();

      }

      this.Visitorscount=this.langService.currentLanguage == 'en'?sessionStorage.getItem('visitorcount'):sessionStorage.getItem('marathi_visitorcount');

  }

  private BaseURL = environment.BaseURLforImages;
  private RawIntegratedData: any[] = [];
  protected disclaimerTitle:any;
  protected termsAndConditionsTitle:any;

  governmenticon;

  Language: any;
  slidesStore: any[] = [];

  private redirectToNewAppURL: any;
  confirmationModal: any;
  Visitorscount:any=0;
  initializeModals(): void {
    this.confirmationModal = new bootstrap.Modal(
      document.getElementById('confirmationModal'),
      { backdrop: 'static', focus: true, keyboard: false }
    );
    this.confirmationModal._element.addEventListener('hide.bs.modal', () => {});
    this.confirmationModal._element.addEventListener('show.bs.modal', () => {});
    this.confirmationModal._element.addEventListener(
      'shown.bs.modal',
      () => {}
    );
  }

  private ChangeLanguageSettings() {
    if(this.RawIntegratedData != null && this.RawIntegratedData.length > 0) {
      this.RawIntegratedData.map((data:any)=>{
        if(data.quicklinkfooterid === 1){
          this.termsAndConditionsTitle = this.langService.currentLanguage == 'en' ? data.titleenglish : data.titlelocal
        }
        if(data.quicklinkfooterid === 2){
          this.disclaimerTitle = this.langService.currentLanguage == 'en' ? data.titleenglish : data.titlelocal
        }
      });
      this.Visitorscount=this.langService.currentLanguage == 'en'?sessionStorage.getItem('visitorcount'):sessionStorage.getItem('marathi_visitorcount');
    }
  }

  private async socialgovermenticon(Integrated: any,): Promise<void> {
    if (Integrated && Integrated.length > 0) {
      this.slidesStore = [];
      await Promise.all(
        Integrated.map(async (res: any) => {
          let obj = {
            src: res.logopath,
            alt: res.url,
            title: res.logoname,
            id: res.integratedapplicationid,
          };
          this.slidesStore.push(obj);
        })
      );
    }

  }

  // Api Calls

  private getIntegratedSectionData() {
    let Body = {
      type: "string",
      title: "string",
      status: 0,
      detail: "string",
      instance: "string",
      additionalProp1: "string",
      additionalProp2: "string",
      additionalProp3: "string"
    };

    this.homeService.getIntegratedSection(Body).subscribe((data: any) => {
      if (data.data.length > 0) {
        this.RawIntegratedData = data.data;
        this.ChangeLanguageSettings();
        this.socialgovermenticon(data.data);
      }
    });
  }

  private getQucikLinkFooterSectionData() {
    let Body = {
      type: "string",
      title: "string",
      status: 0,
      detail: "string",
      instance: "string",
      additionalProp1: "string",
      additionalProp2: "string",
      additionalProp3: "string"
    };

    this.homeService.getFooterSection(Body).subscribe((data: any) => {
      if (data.data.length > 0) {
        this.RawIntegratedData = data.data;
        this.ChangeLanguageSettings();
      }
    });
  }

  private SubscribeLanguage() {
    this.langService.language$.subscribe(
      () => {
        this.ChangeLanguageSettings();
      }
    );
  }

  openRedirectModal(url: string) {
    this.confirmationModal.show();
    this.redirectToNewAppURL = url;
    return false;
  }

  openSlideInNewTab(): void {
    this.confirmationModal.hide();
    window.open(this.redirectToNewAppURL, '_blank'); // Opens the URL in a new tab
  }

  async GetIP(): Promise<string> {
    const result: any = await this.citizenService.getip().toPromise();
    return result.ip;
  }
  async InsertVisitor() {
    let body = {
       "visitorid": this.visitorId,
       "ip":  this.ip,
       "browserInfo": this.browserInfo,
       "platform": this.platform
     }

     this.citizenService.insertVisitor(body).subscribe((result: any) => {
       this.getcount_Visitor();
     });
   }
   clearVisitor() {
    sessionStorage.removeItem('visitorId');
  }
  async getcount_Visitor() {

     this.citizenService.GetCountVisitor().subscribe((result: any) => {

      sessionStorage.setItem('visitorcount', result[0].visitor_count);
      sessionStorage.setItem('marathi_visitorcount', result[0].visitor_count_marathi);

      this.Visitorscount=this.langService.currentLanguage == 'en'?sessionStorage.getItem('visitorcount'):sessionStorage.getItem('marathi_visitorcount');

     });
   }


}
